import React, { useRef, useEffect } from 'react';
import * as monaco from 'monaco-editor';
import styled from 'styled-components';
import Typography from '@material-ui/core/Typography';
import { ruleDescription } from '../../config/rule-description';

const Container = styled.div`
  display: flex;
  height: 10em;
`;

interface CriteriaEditorProps {
  currentValue?: string;
  onDescriptionChange: (value: string) => void;
  label: string;
}

const DescriptionEditor: React.FC<CriteriaEditorProps> = ({
  currentValue,
  onDescriptionChange,
  label,
}) => {
  const monacoEditorRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const model = monaco.editor.create(
      monacoEditorRef?.current as HTMLElement,
      {
        value: currentValue,
        language: ruleDescription,
        theme: 'vs-dark',
        minimap: {
          enabled: false,
        },
        lineNumbers: 'off',
      }
    );

    model.onDidChangeModelContent(_ => onDescriptionChange(model.getValue()));

    return () => {
      model.dispose();
    };

    // eslint-disable-next-line
  }, []);
  return (
    <div>
      <Typography>{label}</Typography>
      <Container ref={monacoEditorRef} />
    </div>
  );
};

export default DescriptionEditor;
